import * as L from "leaflet";
import ILayerStyle from "./ILayerStyle";

export default class TheoreticalSectionStyle implements ILayerStyle {
    public getOptions = (): L.GeoJSONOptions => {
        return {
            style: () => {
                return {
                    color: "blue",
                    fillOpacity: 0,
                    interactive: false,
                };
            },
        }
    };
}